import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { API } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'
import QRCode from "react-qr-code";

class OtpSettingDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'OtpSettingDialog')
        }
    }

    state = {
        otp: ''
    }

    componentDidMount() {
        this.reset()
    }

    componentWillUnmount() {
        this.reset()
    }

    reset() {
        this.setState({ otp: '' })
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.handleSubmit()
        }
    }

    handleSubmit = () => {
        if (!this.state.otp.trim()) {
            utils.addToast(this.t('requiredOtp'), 'error')
            return
        }
        utils.apiRequest(
            'post',
            API.OTP_VALIDATE,
            {
                account: this.props.compDialogArgs.account,
                password: this.props.compDialogArgs.password,
                otp_code: this.state.otp
            },
            () => {
                utils.addToast(this.t('success'))
                this.props.loginReset()
                this.props.otpBindingSuccess()
            },
            () => {
                this.reset()
            },
            true
        )
    }

    render() {
        const { classes } = this.props
        return (
            <Dialog open={true} disableBackdropClick={true}  disableEscapeKeyDown={true}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent className={classes.warpper}>
                    <div className={classes.otpTitle}>{this.t('illustrate')}</div>
                    <QRCode
                        style={{width: '100%', maxWidth: '100%', height: 'auto'}}
                        value={this.props.auth.otpUrl}
                        level='Q'
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label={this.t('otp')}
                        name="otp"
                        autoFocus
                        value={this.state.otp}
                        onChange={(event) =>
                            this.setState({
                                otp: event.target.value,
                            })
                        }
                        onKeyPress={this.handleKeyPress}
                    />
                    <div className={classes.illustrate}>{this.t('note')}</div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.handleSubmit()
                        }}
                        color="primary">
                        {this.t('binding')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

OtpSettingDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    auth: PropTypes.object,
    otpBindingSuccess: PropTypes.func,
    compDialogArgs: PropTypes.object,
    loginReset: PropTypes.func
}

const styles = (_theme) => ({
    otpTitle: {
        textAlign: 'center',
        fontSize: '16px',
        paddingBottom: '15px',
    },
    warpper: {
        width: '400px',
    },
    illustrate: {
        color: '#ff0000',
    }
})

export default hoc(styles)(OtpSettingDialog)
